export default {
  sections: {
    business_info: "Informations sur l'entreprise",
    bank_info: 'Informations bancaires',
  },
  form: {
    company_name: {
      label: 'Nom du restaurant',
      placeholder: 'Nom du restaurant',
    },
    business_name: {
      label: "Nom de l'entreprise",
      placeholder: "Nom de l'entreprise",
    },
    owner_full_name: {
      label: 'Nom du propriétaire',
      placeholder: 'Nom du propriétaire',
    },
    business_address: {
      label: "Adresse de l'entreprise",
      placeholder: "Adresse de l'entreprise",
    },
    business_zip_code: {
      label: "Code postal de l'entreprise",
      placeholder: "Code postal de l'entreprise",
    },
    business_city: {
      label: "Ville de l'entreprise",
      placeholder: "Ville de l'entreprise",
    },
    business_country: {
      label: "Pays de l'entreprise",
      options: {
        DE: 'Allemagne',
        GB: 'Royaume-Uni',
        US: 'États-Unis',
      },
    },
    company_phone_number: {
      label: 'Numéro de téléphone du restaurant',
      placeholder: 'Numéro de téléphone du restaurant',
    },
    contact_person_full_name: {
      label: 'Nom du contact',
      placeholder: 'Nom du contact',
    },
    contact_person_phone_number: {
      label: 'Téléphone du contact',
      placeholder: 'Téléphone du contact',
    },
    contact_person_email: {
      label: 'E-mail du contact',
      placeholder: 'E-mail du contact',
    },
    business_bank_account_holder_name: {
      label: 'Titulaire du compte bancaire',
      placeholder: 'Titulaire du compte bancaire',
    },
    business_bank_account_number: {
      label: 'Numéro de compte bancaire',
      placeholder: 'DE01101234567891234567',
    },
    business_bank_routing_number: {
      label: 'Code de routage bancaire',
      placeholder: '110000000',
    },
    business_tax_id: {
      label: 'Numéro de TVA / SIRET',
      placeholder: 'Numéro de TVA / SIRET',
    },
  },
};
